const OAUTH_RETURN_KEY = "growthos.oauth-return-path";
const RETURN_PATH_TTL_MS = 30 * 60 * 1000;

/** Only the home route changes for the AXOS pilot; explicit routes stay put. */
export function workspaceHomeTarget(clientSlug, { pathname, search = "", hash = "" }) {
  return clientSlug === "ibd-assist-axos" && pathname === "/"
    ? `/test/brief${search}${hash}`
    : null;
}

export function safeReturnPath(value) {
  if (typeof value !== "string" || !value.startsWith("/") || value.startsWith("//") || /[\\\u0000-\u0020]/.test(value)) return null;
  try {
    const path = new URL(value, "https://workspace.invalid").pathname.toLowerCase();
    return path.replace(/\/+$/, "") === "/login" ? null : value;
  } catch {
    return null;
  }
}

/** Keep the existing provider callback URL while restoring this tab's deep link. */
export function rememberOAuthReturnPath(path) {
  try {
    window.sessionStorage.setItem(OAUTH_RETURN_KEY, JSON.stringify({ path: safeReturnPath(path) || "/", expiresAt: Date.now() + RETURN_PATH_TTL_MS }));
  } catch {
    // Sign-in still works when browser storage is blocked.
  }
}

export function readOAuthReturnPath() {
  try {
    const saved = JSON.parse(window.sessionStorage.getItem(OAUTH_RETURN_KEY));
    return saved?.expiresAt > Date.now() ? safeReturnPath(saved.path) : null;
  } catch {
    return null;
  }
}

export function clearOAuthReturnPath() {
  try {
    window.sessionStorage.removeItem(OAUTH_RETURN_KEY);
  } catch {
    // No stored return path exists if browser storage is blocked.
  }
}
